export default "__VITE_ASSET__B3anOGrY__"